import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { FREEMIUM_EVENTS_META } from '../../../../../pro/components/FreemiumEventPurchase/helpers';
import { getAsset } from '../../../../../../util/assets';
import FreemiumEventPurchase from '../../../../../pro/components/FreemiumEventPurchase/FreemiumEventPurchase';

const propTypes = {
  eventType: PropTypes.string,
  onConfirmSelection: PropTypes.func.isRequired,
  paidPlansOnly: PropTypes.bool,
};

const EventSKUSelection = ({
  eventType,
  onConfirmSelection,
  paidPlansOnly,
  ...props
}) => {
  const meta = FREEMIUM_EVENTS_META[eventType];

  return (
    <Fragment>
      <img
        src={getAsset(meta.icon)}
        alt="Let's get your event going"
        width="48"
        className="mx-auto mb-2 d-flex"
      />
      <h1 className="text-extra-bold mb-2 text-center">{meta.title}</h1>
      <p className="text-center mb-5">
        Everyone&apos;s photos &amp; videos in one easily shared
        Waldo&ndash;fied album.
      </p>

      <FreemiumEventPurchase
        albumSubtype={eventType}
        onConfirmSelection={onConfirmSelection}
        {...props}
      />
    </Fragment>
  );
};

EventSKUSelection.propTypes = propTypes;

export default EventSKUSelection;
